module.exports = __webpack_public_path__ + "img/xox-logo-2022.f08c8274.png";